import React, { useEffect, useState } from 'react';
import './Hero.css';

const Hero = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 20,
        y: (e.clientY / window.innerHeight) * 20
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" id="hero">
      <div className="hero-background">
        <div 
          className="gradient-orb orb-1" 
          style={{
            transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`
          }}
        ></div>
        <div 
          className="gradient-orb orb-2"
          style={{
            transform: `translate(${-mousePosition.x}px, ${-mousePosition.y}px)`
          }}
        ></div>
        <div 
          className="gradient-orb orb-3"
          style={{
            transform: `translate(${mousePosition.y}px, ${mousePosition.x}px)`
          }}
        ></div>
        <div className="grid-pattern"></div>
      </div>
      
      <div className="container hero-content">
        <div className="hero-badge">
          <span className="badge-dot"></span>
          <span>Trusted by 30+ Companies Worldwide</span>
        </div>

        <h1 className="hero-title">
          Transform Your Business Into
          <span className="gradient-text"> Digital Powerhouse</span>
        </h1>
        
        <p className="hero-subtitle">
          We deliver cutting-edge IT solutions, innovative design, intelligent data engineering, 
          and AI-powered applications that drive measurable success for your business.
        </p>

        <div className="hero-buttons">
          <button className="btn-primary" onClick={scrollToContact}>
            Get Started <span className="arrow">→</span>
          </button>
          <button className="btn-secondary" onClick={scrollToServices}>
            <span>Explore Services</span>
          </button>
        </div>

        <div className="hero-stats">
          <div className="stat-card">
            <div className="stat-number">150+</div>
            <div className="stat-label">Projects Completed</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">50+</div>
            <div className="stat-label">Happy Clients</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">98%</div>
            <div className="stat-label">Satisfaction Rate</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Support Available</div>
          </div>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
        <span>Scroll to explore</span>
      </div>
    </section>
  );
};

export default Hero;
